import { z } from "zod";

export const rebateFormSchema = z.object({
  year: z.coerce
    .number()
    .int("Year must be a whole number")
    .gt(1900, "Year must be greater than 1900"),
  rebate_amount: z.coerce.number().min(0, "Rebate amount must be 0 or greater"),
  dividend_amount: z.coerce
    .number()
    .min(0, "Dividend amount must be 0 or greater"),
  note: z.string().optional(),
});

export type RebateFormValues = z.infer<typeof rebateFormSchema>;
